import * as React from "react";
export function SvgTable14pxSmall(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={14} height={14} {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#BFBFBF"
          d="M5 4v2h3V4h1v2h3v1H9v2h3v1H9v2H8v-2H5v2H4v-2H1V9h3V7H1V6h3V4h1zm3 3H5v2h3V7z"
        />
        <path
          fill="#666"
          d="M12 0a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h11zM1 4v8h11V4H1zm0-1h11V1H1v2z"
        />
      </g>
    </svg>
  );
}
